// extracted by mini-css-extract-plugin
module.exports = {"main":"ordersPage_dateFormatPicker_main__BhazD","bold":"ordersPage_dateFormatPicker_bold__1S3Lv"};